// src/components/Attestation/AttestationServices.js
import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import attestationData from './attestationData';
import './AttestationServices.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ 
          ...style, 
          display: "block", 
          left: "20px", 
          zIndex: 2 
        }}
        onClick={onClick}
      >
        {/* Example using Font Awesome icon */}
        <i className="fa fa-chevron-left custom-arrow-icon"></i>
      </div>
    );
  }
  
  // Custom arrow for the right side
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ 
          ...style, 
          display: "block", 
          right: "20px", 
          zIndex: 2 
        }}
        onClick={onClick}
      >
        {/* Example using Font Awesome icon */}
        <i className="fa fa-chevron-right custom-arrow-icon"></i>
      </div>
    );
  }

function AttestationServices() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />
  };

  return (
    <section className="attestation-services-page">
      <h1 className="attestation-page-title">Attestation Services</h1>
      <Slider {...settings}>
        {attestationData.map((item) => (
          <div key={item.id}>
            <div
              className="attestation-card"
              style={{ backgroundImage: `url(${item.image})` }}
            >
              <div className="attestation-overlay">
                <div className="attestation-content">
                  <h2>{item.title}</h2>
                  <p>{item.shortDescription}</p>
                  <Link to={`/attestation/${item.id}`} className="learn-more-button">
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default AttestationServices;
